import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ProfileHttpService} from "../../../../../services/http-services/profile/profile-http.service";
import {FormControlErrorMessagesModule} from "../../../../../pipes/form-control-error-messages/form-control-error-messages.module";
import {NgClass, NgIf} from "@angular/common";
import {SpinnerComponent} from "../../../../../shared-components/spinner/spinner.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'tl-edit-profile-bio',
  standalone: true,
  templateUrl: './edit-profile-bio.component.html',
  imports: [
    FormControlErrorMessagesModule,
    NgIf,
    ReactiveFormsModule,
    NgClass,
    SpinnerComponent,
    TranslateModule
  ]
})
export class EditProfileBioComponent implements OnInit, OnChanges {
  @Input() profileData: any;
  @Output() changeProfile: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelChanges: EventEmitter<void> = new EventEmitter<void>();
  isSpinnerActive = false;
  formTriedToSubmit = false;
  editProfileBioForm!: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private toastService: ToastrService,
              private profileHttpService: ProfileHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileDate && changes.profileData.currentValue) {
      this.editProfileBioForm.patchValue(changes.profileData.currentValue);
    }
  }

  buildForm(): void {
    this.editProfileBioForm = this.formBuilder.group({
      bio: ['', [Validators.required]],
    });
    this.editProfileBioForm.patchValue(this.profileData);
  }

  onCancelChanges(): void {
    this.editProfileBioForm.reset();
    this.editProfileBioForm.patchValue(this.profileData);
    this.cancelChanges.emit();
  }

  onSubmitEditProfileNameForm(): void {
    this.formTriedToSubmit = false;
    if (this.editProfileBioForm.valid) {
      this.isSpinnerActive = true;
      this.profileHttpService.editAuthUserProfile(this.editProfileBioForm.value).then(res => {
        this.isSpinnerActive = false;
        this.changeProfile.emit(res.data);
        this.toastService.success(res.message);
      }).catch(({error}: {error:{ errors: { [key: string]: string }}}) => {
        this.isSpinnerActive = false;
        Object.values(error.errors).forEach(error => this.toastService.error());
      });
    }
  }
}
